module.exports = __webpack_public_path__ + "img/btn_linelogin.98e339a6.svg";